var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list", class: _vm.listClasses },
    [_c(_vm.listType, { tag: "component", attrs: { listData: _vm.listData } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }